import * as React from 'react';
import { useLocation, useNavigate, useParams, Location, NavigateFunction } from 'react-router-dom';

export interface IWithRouterProps {
    location: Location;
    history: {
        push: (path: string | Partial<Location>) => void;
        replace: (path: string | Partial<Location>) => void;
        go: (n: number) => void;
        goBack: () => void;
        goForward: () => void;
    };
    match: {
        params: Record<string, string | undefined>;
    };
    router: {
        location: Location;
        navigate: NavigateFunction;
        params: Record<string, string | undefined>;
    };
}

export function withRouter<P extends object>(Component: React.ComponentType<P>) {
    return function ComponentWithRouterProp(props: Omit<P, keyof IWithRouterProps>) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();
        
        const history = {
            push: (path: string | Partial<Location>) => navigate(path as any),
            replace: (path: string | Partial<Location>) => navigate(path as any, { replace: true }),
            go: (n: number) => navigate(n),
            goBack: () => navigate(-1),
            goForward: () => navigate(1),
        };

        const match = { params };

        return (
            <Component
                {...(props as any)}
                router={{ location, navigate, params }}
                location={location}
                history={history}
                match={match}
            />
        );
    }
}
